/**
 * Modern AJAX add to cart for single product page (no jQuery except WooCommerce event triggers).
 */
export async function handleAddToCartClick(e, form) {
    const btn = e.currentTarget;
    if (btn.classList.contains("disabled")) return;

    if (!form) return;

    e.preventDefault();
    await ajaxAddToCart(btn, form);
}

async function ajaxAddToCart(btn, form) {
    const formData = new FormData(form);
    if (!formData.has("product_id")) {
        formData.append("product_id", btn.value);
    }

    // Trigger WooCommerce 'adding_to_cart' event
    if (window.jQuery) {
        window
            .jQuery(document.body)
            .trigger("adding_to_cart", [window.jQuery(btn), Object.fromEntries(formData.entries())]);
    }

    btn.disabled = true;
    btn.classList.remove("added");
    btn.classList.add("loading");
    try {
        const response = await fetch(
            wc_add_to_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "add_to_cart"),
            {
                method: "POST",
                body: formData,
            },
        );
        const result = await response.json();

        btn.classList.add("added");
        btn.classList.remove("loading");
        btn.disabled = false;

        if (result.error && result.product_url) {
            window.location.reload();
            return;
        }

        // Trigger WooCommerce 'added_to_cart' event
        if (window.jQuery) {
            window
                .jQuery(document.body)
                .trigger("added_to_cart", [result.fragments, result.cart_hash, window.jQuery(btn)]);
        }
    } catch (err) {
        btn.classList.remove("loading");
        btn.disabled = false;
    }
    return false;
}
